import { To } from 'react-router-dom';
import { LoadingShape, RenderIf } from 'react-rainbow-components';
import {
    Container, IconContainer, StyledAvatarLoadingShape, StyledLink, Subtitle, Title, TitleContainer,
} from './styled';

interface Props {
    icon?: React.ReactNode;
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    className?: string;
    to?: To;
    isLoading?: boolean;
    onClick?: () => void;
    $variant?: 'default' | 'inline';
}

const ListTile = ({
    icon, title, subtitle, isLoading, to, className, onClick, $variant,
}: Props) => (
    <Container
        as={onClick ? 'button' : undefined}
        type={onClick ? 'button' : undefined}
        className={className}
        onClick={onClick}
    >
        {icon && (
            <IconContainer $variant={$variant}>
                <RenderIf isTrue={!isLoading}>{icon}</RenderIf>
                <RenderIf isTrue={isLoading}>
                    <StyledAvatarLoadingShape variant="avatar" />
                </RenderIf>
            </IconContainer>
        )}
        <TitleContainer>
            <RenderIf isTrue={isLoading}>
                <LoadingShape />
            </RenderIf>
            <RenderIf isTrue={!isLoading}>
                <Title as={(to && StyledLink)} to={to} data-id="title" $variant={$variant}>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </RenderIf>
        </TitleContainer>
    </Container>
);

export default ListTile;
